<template>
  <li class="dropdown top-nav__notifications" data-placement="left" data-toggle="tooltip" title="" :data-original-title="trans">
    <a href="" data-toggle="dropdown"  :class="{ 'top-nav__notify': isActive }">
      <i class="zmdi zmdi-notifications"></i>
    </a>
    <div class="dropdown-menu dropdown-menu-right dropdown-menu--block" v-bind:class="{ 'top-nav__notifications--cleared': isComplete }">
      <div class="listview listview--hover">
        <div class="listview__header">
          {{ title }}
          <div class="actions">
            <a href="" class="actions__item zmdi zmdi-check-all" data-ma-action="notifications-clear" v-on:click="readAll()"></a>
          </div>
        </div>
        <div class="listview__scroll scrollbar-inner">
          <a :href="url+'/notifications/'+item.id" class="listview__item" v-for="item in notifications" :key="item.id">
            <img :src="item.data.image" class="listview__img" alt="">
            <div class="listview__content">
              <div class="listview__heading">{{ item.data.name }} <small>{{ item.data.type }}</small></div>
              <p>{{ item.data.description }}</p>
            </div>
          </a>
        </div>
        <a :href="url+'/notifications/my/history'" class="view-more hide">{{ subtitle }}</a>
        <div class="p-1"></div>
      </div>
    </div>
  </li>
</template>
<script>
export default {
  props:  ['user','title','url','subtitle','trans'],
  data() {
    return {
      notifications: [] ,
      isActive: false,
      isComplete:true
    }
  },
  methods: {
    readAll:function(){
      axios.get( this.url+'/user/readall')
        .then( response => {
          if(response.data.data){
            if(response.data.data.length > 0){
              this.notifications = response.data.data.map( item => {
                return {
                  notifiable_type: item.notifiable_type,
                  type: item.type,
                  read_at: item.read_at,
                  id: item.id,
                  data: item.data.data
                }
              });
            }else{
              this.notifications = [];
            }
            this.isActive      = this.notifications.length > 0 ? true : false;
            this.isComplete    = this.notifications.length > 0 ? false : true;
          }
        });
    }
  },
  mounted(){
    axios.get( this.url+'/user/notifications')
      .then( response => {
        if(response){
          if(response.data.data.length > 0){
            this.notifications = response.data.data.map( item => {
              return {
                notifiable_type: item.notifiable_type,
                type: item.type,
                read_at: item.read_at,
                id: item.id,
                data: item.data.data
              }
            });
          }else{
            this.notifications = [];
          }
          this.isActive      = this.notifications.length > 0 ? true : false;
          this.isComplete    = this.notifications.length > 0 ? false : true;
        }
        Echo.private(`App.User.${this.user}`)
          .notification(notification => {
            if(notification){
              console.log(notification);
              this.notifications.unshift({
                notifiable_type: notification.notifiable_type,
                type: notification.type,
                read_at: null,
                id: notification.id,
                data: notification.data
              })
            }
            this.isActive      = this.notifications.length > 0 ? true : false;
            this.isComplete    = this.notifications.length > 0 ? false : true;
          });
      });
  }
}
</script>
